import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomDialog from '../Dialogs';
import { Typography } from '@mui/material';
import NdcImportMarket from './NdcImportMarket';
import SourceSelectionDialog from './SourceSelectionDialog';
import { SourceType, SOURCE_NDC_X } from './types';

export const RenderImportDialog = ({ viewDialog, setViewDialog }) => {
  const [showRegionSelection, setShowRegionSelection] = useState(true);
  const navigate = useNavigate();

  const handleSourceNext = (source: SourceType) => {
    if (source === SOURCE_NDC_X) {
      setViewDialog(false);
      navigate('/tff/ndcx-import');
    } else {
      setShowRegionSelection(false);
    }
  };

  const handleCancel = () => {
    setViewDialog(false);
    setShowRegionSelection(true);
  };

  if (showRegionSelection) {
    return <SourceSelectionDialog isOpen={viewDialog} onCancel={handleCancel} onNext={handleSourceNext} />;
  }

  return (
    <CustomDialog
      initialOpen={viewDialog}
      confirmButtonText="Close"
      confirmButtonStyle={{
        backgroundColor: '#F2E30F',
        color: 'black',
      }}
      onConfirm={handleCancel}
      onCancel={handleCancel}
      width="md"
      cancelButtonText=""
      titleBg="#E2F3FE"
      title={
        <Typography variant="h5" align="left" fontWeight="bold">
          NDC-REIMPORT
        </Typography>
      }
    >
      <NdcImportMarket setViewDialog={setViewDialog} />
    </CustomDialog>
  );
};
